module.exports = __webpack_public_path__ + "static/media/d98fb015-7ef6-404f-a58a-5c9242d79770.c960580e.woff";